module.exports = __webpack_public_path__ + "img/permata.1f2011b2.svg";